module.exports = __webpack_public_path__ + "assets/b1395799893e1f8649206459e62f98e2.png";